import { Tooltip } from "@mui/material";
import { ChangeManagementPlan } from "src/types/change-management";

const statuses = {
  ok: { label: "Complete", hint: null },
  partial: {
    label: "Incomplete",
    hint: "Missing evidence could change these recommendations",
  },
};

export const PlanStatus = ({
  status,
}: {
  status: ChangeManagementPlan["status"];
}) => {
  const { label, hint } = statuses[status];
  const content = (
    <span className="whitespace-nowrap text-black/[.87]">{label}</span>
  );
  return hint ? (
    <Tooltip title={hint} describeChild>
      {content}
    </Tooltip>
  ) : (
    content
  );
};
